const EXPIRED_ITEMS = 'EXPIRED_ITEMS';

export const ERROR = {
  EXPIRED_ITEMS,
};
